import {
  EntityObject,
  getRequiredObjectId,
  ObjectDocumentAssocSelectorProps,
  objectDocumentAssocsSelector, ObjectDocumentAssocEntity,
  useGetAllObjectDocumentAssocsByObjectQuery
} from "@ots-frontend/ots-data";
import {useMemo, useState} from "react";
import {BaseObjectDocumentAssocSelect, BaseObjectDocumentAssocSelectProps} from "./BaseObjectDocumentAssocSelect";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type ObjectDocumentAssocSelectProps = Omit<BaseObjectDocumentAssocSelectProps, 'entities' | 'loading'> & {
  selector?: ObjectDocumentAssocSelectorProps
  entity: EntityObject | string
};

export const ObjectDocumentAssocSelect = (props: ObjectDocumentAssocSelectProps) => {
  const {entity, selector, ...rest} = props;

  const selectObjectDocumentAssocs = useMemo(() => {
    return objectDocumentAssocsSelector()
  }, [])

  const {objectDocumentAssocs, isLoading} = useGetAllObjectDocumentAssocsByObjectQuery(getRequiredObjectId(entity), {
    selectFromResult: (result) => ({
      objectDocumentAssocs: selectObjectDocumentAssocs(result),
      isLoading: result.isLoading,
    })
  });

  return <BaseObjectDocumentAssocSelect entities={objectDocumentAssocs} loading={isLoading} {...rest} />;
};

export interface ObjectDocumentAssocSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: Omit<ObjectDocumentAssocSelectProps, 'entity'>
  entity: EntityObject | string
  onSubmit?: (objectDocumentAssocs: ObjectDocumentAssocEntity[] | undefined) => void
}

export const ObjectDocumentAssocSelectModal = (props: ObjectDocumentAssocSelectModalProps) => {
  const {
    select,
    entity,
    onSubmit,
    ...rest
  } = props;

  const [selectedObjectDocumentAssocs, setSelectedObjectDocumentAssocs] = useState<ObjectDocumentAssocEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <ObjectDocumentAssocSelect
          {...select}
          entity={entity}
          onEntityChange={e => setSelectedObjectDocumentAssocs(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedObjectDocumentAssocs);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
